import React, { useState, useEffect } from 'react';
import { fetchCategoryById, createCategory, updateCategory } from '../../../components/API/Store/categoryAPI';
import './AddEditCategory.css';

const AddEditCategory = ({ id, onSave, onCancel }) => {
    const [name, setName] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (id) {
            fetchCategory(id);
        }
    }, [id]);

    const fetchCategory = async (categoryId) => {
        setLoading(true);
        setError('');
        try {
            const { success, category, message } = await fetchCategoryById(categoryId);
            if (success) {
                setName(category.name);
            } else {
                setError(message);
            }
        } catch (err) {
            setError('An error occurred while fetching the category.');
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            const { success, message, category } = id
                ? await updateCategory(id, name)
                : await createCategory(name);

            if (success) {
                onSave(category);
            } else {
                setError(message);
            }
        } catch (err) {
            setError(`An error occurred while ${id ? 'updating' : 'creating'} the category.`);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return <div className="loading">Loading...</div>;
    }

    return (
        <div className="add-edit-category-container">
            <form onSubmit={handleSubmit} className="add-edit-category">
                <h2>{id ? 'Edit' : 'Add'} Category</h2>
                {error && <div className="error-message">{error}</div>}
                <div className="form-group">
                    <label htmlFor="categoryName">Name</label>
                    <input
                        type="text"
                        id="categoryName"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                        disabled={loading}
                    />
                </div>
                <div className="form-actions">
                    <button type="submit" disabled={loading}>
                        {loading ? 'Processing...' : (id ? 'Update' : 'Add') + ' Category'}
                    </button>
                    <button type="button" onClick={onCancel} disabled={loading}>
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    );
};

export default AddEditCategory;